// src/context/AppProviders.js
import React from 'react';
import { CronometroProvider } from './CronometroContext';
import { EventProvider } from './EventContext';
import { AuthProvider } from './AuthContext'; // Importar AuthProvider
import { CompetenciaProvider } from './CompetenciaContext'; // Asegúrate de crear este contexto
import { InscripcionesProvider } from './InscripcionesContext';

const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <CompetenciaProvider>
        <InscripcionesProvider>
          <EventProvider>
            <CronometroProvider>
                {children}
            </CronometroProvider>
          </EventProvider>
        </InscripcionesProvider>
      </CompetenciaProvider>
    </AuthProvider>
  );
};

export default AppProviders;
